<template>
    <v-form :name="props.searchProps.formName"
            @keyup.enter="autoSearch = true">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Search condition') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormCalendar fieldName="activity_date_from"
                                      label="Activity date from"
                                      size="2"
                                      showTime
                                      hourFormat="24"
                                      v-model:field="search.activity_date_from" />
                        <FormCalendar fieldName="activity_date_to"
                                      label="Activity date to"
                                      size="2"
                                      showTime
                                      hourFormat="24"
                                      v-model:field="search.activity_date_to" />

                        <FormMultiselect fieldName="dcttype_id"
                                         label="Type"
                                         size="4"
                                         :showClear="true"
                                         :options="select?.dct_activity_types"
                                         v-model:field="search.dcttype_id" />

                        <FormMultiselect fieldName="creator_id"
                                         label="Creator"
                                         size="4"
                                         :options="select?.users"
                                         v-model:field="search.creator_id" />
                    </div>
                    <div class="grid">
                        <FormSelect fieldName="source_table"
                                    label="Binded area"
                                    size="2"
                                    :showClear="true"
                                    :options="select?.activity_tables"
                                    :change="(e) => getRecordForSelectedTable(e.value)"
                                    v-model:field="search.source_table" />

                        <FormMultiselect fieldName="source_id"
                                         label="Binded data"
                                         size="10"
                                         :showClear="true"
                                         :options="select?.activity_table_records"
                                         v-model:field="search.source_id" />
                    </div>
                    <div class="grid">

                    </div>
                    <div class="grid">
                        <FormInputText fieldName="subject"
                                       label="Subject"
                                       size="6"
                                       v-model:field="search.subject" />

                        <FormMultiselect fieldName="status_id"
                                         label="Status"
                                         size="4"
                                         :options="select?.statuses"
                                         v-model:field="search.status_id" />

                        <FormSelect fieldName="visibility"
                                    label="Visibility"
                                    size="2"
                                    showClear
                                    :options="select?.activity_visibilities"
                                    v-model:field="search.visibility" />
                    </div>
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <SearchButtons :searchProps="searchProps"
                           :search="search"
                           v-model:autoSearch="autoSearch" />
        </div>
    </v-form>
</template>

<script setup>
import { ref, onMounted } from "vue";
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import FormSelect from '@crud/FormSelect.vue'
import FormCalendar from '@crud/FormCalendar.vue';
import FormInputText from '@crud/FormInputText.vue'
import FormMultiselect from '@crud/FormMultiselect.vue'
import SearchButtons from '@crud/SearchButtons.vue'
import { prepareSearch } from '@pages/Helper/crud_utils.js'
import { __, getFromRoute } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    searchProps: Object,
})
const autoSearch = ref(false)

let search = ref({})

const options = ["dct_activity_types", "activity_visibilities", "users", "statuses", "activity_tables", "activity_table_records"];
const select = ref(null);

prepareSearch(search, props, options, select, { 'statuses': { 'status_category': 'STA_ACTIVITY' } })

// -----------------------------------------------------

onMounted(async () => {
    // // search.value.source_id = null
    //  search.value.source_table = null
    getRecordForSelectedTable(search.value.source_table)
})

// -----------------------------------------------------

const getRecordForSelectedTable = async (table) => {
    if (!table) {
        select.value.activity_table_records = []
        search.value.source_id = null
        return;
    }
    const response = await getFromRoute('helper-select', { select: 'table_records', params: { 'table': table } })
    select.value.activity_table_records = response.table_records
}

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
